<template>
  <div class="app-container">
    <CrudTable entity="Client" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: ['name', { field: 'domainName', label: 'common.domain' }, 'phone', 'companyEmail']
    };
  },
  created() {
    this.$store.dispatch('vatType/getItems');
  },
  methods: {
    generateSummary({ name, domainName }) {
      return `${name} (${domainName})`;
    }
  }
};
</script>
